import * as XLSX from 'xlsx'

export function exportToExcel(items, title) {
    if (!items || items.length === 0) {
        alert('No data to export')
        return
    }

    // Step 1: Identify keys where all values are primitives
    const keys = Object.keys(items[0])
    const allowedKeys = keys.filter(key =>
        items.every(item => {
            const value = item[key]
            return (
                value === null ||
                typeof value === 'string' ||
                typeof value === 'number' ||
                typeof value === 'boolean'
            )
        })
    )

    // Step 2: Build a new list of rows with only allowed keys
    const filteredItems = items.map(item => {
        const filteredRow = {}
        allowedKeys.forEach(key => {
            filteredRow[key] = item[key]
        })
        return filteredRow
    })

    // Step 3: Export to Excel
    const worksheet = XLSX.utils.json_to_sheet(filteredItems)
    const workbook = XLSX.utils.book_new()
    XLSX.utils.book_append_sheet(workbook, worksheet, 'Sheet1')

    const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' })
    const blob = new Blob([excelBuffer], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    })

    const url = URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${title.toLowerCase().replace(/\s+/g, '_')}_export.xlsx`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}

export function exportToCsv(items, title) {
    if (!items || items.length === 0) {
        alert('No data to export')
        return
    }

    const keys = Object.keys(items[0])
    const csv = [
        keys.join(','), // header row
        ...items.map(row => keys.map(k => JSON.stringify(row[k] ?? '')).join(',')),
    ].join('\n')

    const blob = new Blob([csv], { type: 'text/csv' })
    const url = window.URL.createObjectURL(blob)
    const link = document.createElement('a')
    link.href = url
    link.download = `${title.toLowerCase().replace(/\s+/g, '_')}_export.csv`
    document.body.appendChild(link)
    link.click()
    document.body.removeChild(link)
}
